import React,{useEffect} from 'react'
import { NavLink } from 'react-router-dom';
import { useAappContext } from "../context/AppContext";
import { useNewsEventContext } from '../context/NEVContext';

const NewsEvent = (newsEvent) => {
  const {getNewsEvent}=useNewsEventContext();
  

  
  const {getApiHost,ApiHost} =useAappContext();
useEffect(()=>{
  getApiHost()
},[])
  const {id:evnid,title,image}=newsEvent;
  return (
    <>
        <div className="event">
        <img src={`${ApiHost}${image}`} alt=""/>
        <div className="title">
            <h3>{title}</h3>
            <NavLink to={'/news/'+evnid} onClick={()=> getNewsEvent(title,image,newsEvent)}> 
            <button className="normal">details</button> 
            </NavLink>
        </div>
        </div>

    </>
  )
}

export default NewsEvent